import { forwardRef } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import type { PendingUndo } from '../../hooks/useUndoDelete'

// Deleted “<name>” + Undo (ux/03 UndoToast): an inverted bar, 5 s, one at a
// time. role="status" so it is announced; keyboard deletes move focus here.
// An add shows Added “<name>” the same way; a bulk add from a recipe or the
// plan says what it did ("Added to your list: 4 new, 2 changed").
export const UndoToast = forwardRef<HTMLButtonElement, {
  pending: PendingUndo | null
  layout: 'phone' | 'desktop'
  onUndo: () => void
}>(function UndoToast({ pending, layout, onUndo }, undoRef) {
  return (
    <div className={`ml-toast-slot ml-toast-slot--${layout}`} role="status" aria-live="polite">
      <AnimatePresence>
        {pending && (
          <motion.div key={pending.seq} className="ml-toast"
            initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
            transition={{ duration: 0.2, ease: [0.2, 0.8, 0.2, 1] }}>
            <span className="ml-toast__text">{textOf(pending)}</span>
            <span className="ml-visually-hidden">Undo available.</span>
            <button ref={undoRef} type="button" className="ml-text-btn" onClick={onUndo}>Undo</button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
})

const textOf = (p: PendingUndo) =>
  p.kind === 'bulk' ? p.text : p.kind === 'delete' ? `Deleted “${p.item.name}”` : `Added “${p.name}”`
